import React, { useContext } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import { DialogTitle, IconButton, DialogActions } from "@mui/material"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import { useDispatch, useSelector } from "react-redux"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import TokenContext from "../../context/TokenContext"
import { UserAuth } from "../../context/AuthContext"
import CustomSelect from "../CustomSelect"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomTextField from "../CustomTextField"
import CustomDateField from "../CustomDateField"

const ModalDesarrollosNoPasibles = ({ open, handleClose, onSubmit }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch()
    const { empleado } = UserAuth()

    const defaultValues = {
        new_name: '',
        new_descripcion: '',
    }

    const validacionSchema = yup.object().shape({
        new_name: yup.string().required("Required"),
        new_descripcion: yup.string().required("Required"),
    })

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Crear Desarrollo no pasible Propiedad Intelectual</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_name"
                                label="Producto"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el Producto."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_descripcion"
                                label="Descripción"
                                multiline
                                rows={4}
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la descripción."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                        <Typography sx={{ fontWeight: 'bold' }}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>Crear</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalDesarrollosNoPasibles